export function generateOptions(options: string[]) {
    return options.map((item) => {
        return { value: item, text: item };
    });
}
